import Cookies from "js-cookie";
import Swiper from "swiper/bundle";
import he from "he";
import "select2";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
(function ($, Drupal) {
  function formatStateCarte(state) {
    if (!state.id) {
      return state.text;
    }
    var contructionSN =
      '<a class="row" href="' + state.sn_url + '"><div class="grid-x">';
    contructionSN +=
      '<div class="logo small-2 medium-1 large-2 cell"><img src="' +
      state.logo_url +
      '" class="img-flag" /></div>';
    contructionSN +=
      '<div class="text small-10 medium-11 large-10 medium cell">';
    contructionSN += state.text;
    contructionSN += "</div></div></a>";
    var $state = $(contructionSN);
    return $state;
  }
  function formatStateAnnuaire(state) {
    if (!state.id) {
      return state.text;
    }
    var contructionSN =
      '<a class="row" href="' + state.annuaire_url + '"><div class="grid-x">';
    contructionSN +=
      '<div class="logo small-2 medium-1 large-2 cell"><img src="' +
      state.logo_url +
      '" class="img-flag" /></div>';
    contructionSN +=
      '<div class="text small-10 medium-11 large-10 medium cell">';
    contructionSN += state.text;
    contructionSN += "</div></div></a>";
    var $state = $(contructionSN);
    return $state;
  }
  function stripStateCarte(selection) {
    if (!selection.id) {
      return selection.text;
    }
    var contructionSelection =
      '<a class="row" href="' + selection.sn_url + '"><div class="grid-x">';
    contructionSelection +=
      '<div class="logo small-2 medium-1 large-2 cell"><img src="' +
      selection.logo_url +
      '" class="img-flag" /></div>';
    contructionSelection +=
      '<div class="text small-10 medium-11 large-10 medium cell">';
    contructionSelection += selection.text;
    contructionSelection += "</div></div></a>";
    var $selection = $(contructionSelection);
    return $selection;
  }
  function stripStateAnnuaire(selection) {
    if (!selection.id) {
      return selection.text;
    }
    var contructionSelection =
      '<a class="row" href="' +
      selection.annuaire_url +
      '"><div class="grid-x">';
    contructionSelection +=
      '<div class="logo small-2 medium-1 large-2 cell"><img src="' +
      selection.logo_url +
      '" class="img-flag" /></div>';
    contructionSelection +=
      '<div class="text small-10 medium-11 large-10 medium cell">';
    contructionSelection += selection.text;
    contructionSelection += "</div></div></a>";
    var $selection = $(contructionSelection);
    return $selection;
  }
  Drupal.behaviors.gestionReveal = {
    attach: function (context, settings) {
      // ouverture reveal accueil automatique
      if ($("#popup_accueil").length) {
        // console.log(Cookies.get());
        if (Cookies.get("popup") != "opened") {
          $("#popup_accueil").foundation("open");
          Cookies.set("popup", "opened", { expires: 1 });
        }
        // arret video quand reveal fermé
        $("#popup_accueil").on("closed.zf.reveal", function () {
          $("#popup_accueil iframe").each(function (i) {
            $(this).attr("src", $(this).attr("src"));
          });
        });
      }
    },
  };
  Drupal.behaviors.printAnnuaire = {
    attach: function (context, settings) {
      if ($("a.annuaire-pdf").length) {
        const annuaire = "/exports/annuaire.json";
        $("a.annuaire-pdf").after(
          '<table id="annuaire_pdf" class="hide"></table>'
        );
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();
        var doc = new jsPDF({
          orientation: "landscape",
        });
        doc.setFontSize(4.5);
        doc.setTextColor("#000061");
        doc.setLanguage("fr-FR");
        doc.setProperties({
          title: "Annuaire des Scènes nationales",
          author: "Association des Scènes nationales",
          creator: "Association des Scènes nationales",
        });
        $.getJSON(annuaire, function (data) {
          var items = [];
          data.forEach((element, index, array) => {
            items.push([
              he.decode(element.scene_nationale),
              element.ville,
              element.direction,
              element.adresse_1,
              element.adresse_2,
              element.cp,
              element.adresse_ville,
              element.departement,
              element.email,
            ]);
          });
          autoTable(doc, {
            head: [
              [
                "Scène nationale",
                "Ville",
                "Direction",
                "Adresse postale",
                "",
                "",
                "",
                "Département",
                "Email administration",
              ],
            ],
            body: items,
            theme: "grid",
            margin: 9,
            styles: {
              fontSize: 4.5,
              textColor: "#000061",
              lineColor: "#E8E8E8",
              cellPadding: 0.3,
              //   lineWidth: "1px",
            },
            columnStyles: { 0: { fontStyle: "bold" } },
            headStyles: {
              fontStyle: "bold",
              fillColor: "#ff6d7c",
              cellPadding: { top: 1, right: 0.3, bottom: 1, left: 0.3 },
            },
            footStyles: {
              fontSize: 4.5,
              fontStyle: "bold",
              textColor: "#000061",
            },
            didDrawPage: function () {
              var dateFooter = dd + "/" + mm + "/" + yyyy;
              var pageSize = doc.internal.pageSize;
              var pageHeight = pageSize.height
                ? pageSize.height
                : pageSize.getHeight();
              doc.text(dateFooter, 9, pageHeight - 5.5);
            },
          });
        });
        $("a.annuaire-pdf").click(function () {
          var filename = "Annuaire_ASN_" + dd + "-" + mm + "-" + yyyy + ".pdf";
          doc.save(filename);
        });
      }
    },
  };
  Drupal.behaviors.befDrilldownRessources = {
    attach: function (context, settings) {
      if ($("#edit-classement.bef-links").length) {
        $("#edit-classement.bef-links  ul")
          .addClass("vertical")
          .addClass("menu");
        var backButton = '<a tabindex="0">Retour</a>';
        $("#edit-classement.bef-links ul > ul").addClass("nested");
        var drill = new Foundation.Drilldown(
          $("#edit-classement.bef-links > ul", context).once(
            "befDrilldownRessources"
          ),
          {
            "data-auto-apply-class": true,
            "data-parent-link": true,
            "data-auto-height": true,
          }
        );
        $(".js-drilldown-back").html(backButton);
        if ($(".bef-link--selected").length) {
          var selectedSubMenu = $(".bef-link--selected").parent();
          selectedSubMenu.parent().parent().addClass("bef-parent--selected");
          $("#edit-classement.bef-links ul").foundation(
            "_showMenu",
            selectedSubMenu,
            false
          );
        }
      }
    },
  };
  Drupal.behaviors.containerAccordion = {
    attach: function (context, settings) {
      if ($("li.accordion-item").length) {
        $("li.accordion-item", context)
          .once("containerAccordionItem")
          .wrapAll(
            '<ul class="accordion" data-accordion data-allow-all-closed="true" />'
          );
        $(".accordion", context).once("containerAccordion").foundation();
      }
    },
  };
  Drupal.behaviors.carteSelect2 = {
    attach: function (context, settings) {
      if ($("#acces_rapide #select_sn").length) {
        const datajson = "/cartes/sn.json";
        $.getJSON(datajson, function (sn_data) {
          const groupbyregion = sn_data.reduce((r, { region, ...rest }) => {
            if (!r[region]) r[region] = { region, children: [rest] };
            else r[region].children.push(rest);
            return r;
          }, {});
          const groupbyregionFinal = $.map(groupbyregion, function (obj) {
            obj.text = obj.text || obj.region; // replace name with the property used for the text
            return obj;
          });
          $(".js-data", context)
            .once("carteSelect2")
            .select2({
              language: {
                searching: function () {
                  return "Recherche en cours…";
                },
              },
              data: groupbyregionFinal,
              closeOnSelect: false,
              templateResult: formatStateCarte,
              templateSelection: stripStateCarte,
              allowClear: true,
              placeholder: "Découvrez une Scène nationale",
            });
          $(".js-data").val(null);
          $(".js-data").trigger("change");
        });
        $(".js-data").one("select2:open", function (e) {
          $("input.select2-search__field").prop(
            "placeholder",
            "Recherchez par ville ou nom de la structure"
          );
        });
      }
      if ($("#consult_annuaire #select_sn").length) {
        const datajson = "/annuaire/sn.json";
        $.getJSON(datajson, function (sn_data) {
          const groupbyregion = sn_data.reduce((r, { region, ...rest }) => {
            if (!r[region]) r[region] = { region, children: [rest] };
            else r[region].children.push(rest);
            return r;
          }, {});
          const groupbyregionFinal = $.map(groupbyregion, function (obj) {
            obj.text = obj.text || obj.region; // replace name with the property used for the text
            return obj;
          });
          $(".js-data", context)
            .once("carteSelect2")
            .select2({
              language: {
                searching: function () {
                  return "Recherche en cours…";
                },
              },
              data: groupbyregionFinal,
              closeOnSelect: false,
              templateResult: formatStateAnnuaire,
              templateSelection: stripStateAnnuaire,
              allowClear: true,
              placeholder: "consultez l'annuaire d'une Scène nationale",
            });
          $(".js-data").val(null);
          $(".js-data").trigger("change");
        });
        $(".js-data").one("select2:open", function (e) {
          $("input.select2-search__field").prop(
            "placeholder",
            "Recherchez par ville ou nom de la structure"
          );
        });
      }
    },
  };
  Drupal.behaviors.placeholder = {
    attach: function (context, settings) {
      if ($("#edit-field-budget-global-wrapper").length) {
        $("#edit-field-budget-global-wrapper input", context).attr('placeholder', '3,4 M€');
      }
    }
  }
  Drupal.behaviors.swiper = {
    attach: function (context, settings) {
      if ($(".swiper.view-1").length) {
        $(".swiper.view-1").each(function (i) {
          var diaporama = new Swiper($(this)[0], {
            // autoplay: {
            //  delay: 2500,
            //  disableOnInteraction: false,
            //   },
            autoplay: false,
            loop: true,
            autoHeight: true,
            effect: "fade",
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
          });
        });
      }
      // swiper 3 per view
      if ($(".swiper.view-3").length) {
        $(".swiper.view-3").each(function (i) {
          var diaporama = new Swiper($(this)[0], {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
            breakpoints: {
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            },
          });
        });
      }
    },
  };
  Drupal.behaviors.empreintesVideoModale = {
    attach: function (context, settings) {
      function toEmbedUrl(url) {
        if (!url) return '';
        var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
        if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
        var vim = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (vim) return 'https://player.vimeo.com/video/' + vim[1] + '?autoplay=1';
        return '';
      }
      // L'AJAX views remplace le DOM (modale incluse) -> l'instance Foundation
      // Reveal disparait. On la (re)cree si absente avant chaque ouverture.
      function ensureRevealPlugin($modal) {
        if (!$modal.length) return;
        if ($modal.data('zfPlugin')) return;
        if (window.Foundation && Foundation.Reveal) {
          new Foundation.Reveal($modal);
        }
      }
      $('body').once('empreintesVideoModaleOpen').on('click', '[data-open="modalvideo"][data-video-url]', function (e) {
        e.preventDefault();
        var embed = toEmbedUrl($(this).attr('data-video-url'));
        if (!embed) return;
        $('#modalvideo .video-container').html(
          '<iframe src="' + embed + '" style="border:0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>'
        );
        var $modal = $('#modalvideo');
        ensureRevealPlugin($modal);
        $modal.foundation('open');
      });
      // Bind closed handler sur l'instance courante (renouvelee a chaque AJAX).
      $('#modalvideo', context).off('closed.zf.reveal.empreintesVideo')
        .on('closed.zf.reveal.empreintesVideo', function () {
          $(this).find('.video-container').empty();
        });
    }
  };
  Drupal.behaviors.signature = {
    attach: function (context, settings) {
      $('body').once('signature').each(function () {
        console.log("%cDéveloppement et intégration graphique ➔ formes fluides · Aurélien Goulet et Frédéric Schaffar", "font-size: 13px; background: #000000; padding: 8px;font-weight: 700; color: #BFACAA; border-radius: 5px;");
        console.log("%chttps://formesfluides.fr/", "font-size: 13px; text-decoration: underline; background: #BFACAA; color: #000000; font-weight: 700; border-radius: 5px; padding: 8px;");
      });
    }
  };
})(jQuery, Drupal);
